import { useAuthStore } from "@src/stores/auth";
import { useChatSessionStore } from "@src/stores/chatSession";
import { useMessageStore } from "@src/stores/messages";
import { db } from "@src/services/db";
import "@src/services/echo";

type BotSessionExpiredPayload = {
    session_id: number;
};

export function botSessionExpiredListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const messageStore = useMessageStore();

    const companyId = Number((auth.user as any)?.company_id ?? 0);
    if (!companyId) return;

    // @ts-ignore
    window.websockets
        .private(`company.${companyId}`)
        .listen(".BotSessionExpiredEvent", async (event: BotSessionExpiredPayload) => {
            try {
                const sessionId = Number(event?.session_id);

                // remove apenas a sessão bot do IndexedDB local
                await db.sessions.delete(sessionId);

                // se a sessão expirada estiver aberta, limpa a tela
                if (Number((sessionStore.selectedSession as any)?.id) === sessionId) {
                    sessionStore.clearSession();
                    messageStore.clearBotState?.();
                }
            } catch (e) {
                console.error("❌ erro no listener BotSessionExpiredEvent", e);
            }
        });
}